import { Fragment, useEffect, useState } from "react";
import { Popover, Transition } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { ChevronRightIcon } from "@heroicons/react/solid";
import Hero from "../assets/logoimage.png";
import Planeta from "../assets/planeta_crypto.png";
import "./style.css";
import { FaDiscord } from "react-icons/fa";

export default function Header() {
  return (
    
    <div class="bg-neutral-900">
      {/* <div className="bg-hero"> */}
      <main class="lg:relative">
        <div class="mx-auto max-w-7xl w-full pt-16 pb-20 text-center lg:py-48 lg:text-left">
          <div class="px-4 lg:w-1/2 sm:px-8 xl:pr-16">
            <h1 class="text-4xl tracking-tight font-extrabold text-white sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl">
              <span class="block xl:inline">Cryptonikas DAO</span>
            </h1>
            <p class="mt-3 max-w-md mx-auto text-lg text-gray-100 sm:text-xl md:mt-5 md:max-w-3xl">
              El futuro de la innovación no es una meta, es un camino de
              autoconocimiento. Descubre y construye con nosotras.
            </p>
            <div class="mt-10 sm:flex sm:justify-center lg:justify-start">
              <div class="rounded-full shadow">
                <a
                  target="_blank"
                  href="https://linktr.ee/cryptonikasdao"
                  //target="_blank"
                  class="rounded-full flex items-center justify-center px-4 py-2 border border-transparent text-lg font-medium rounded-full text-white bg-violet-600 hover:bg-violet-800 md:py-4 md:text-lg md:px-10"
                >
                  {" "}
                  Únete a la nave 🛸
                </a>
              </div>
            </div>
          </div>
          {/* <img class="relative rounded-lg shadow-lg" src={Planeta} alt="App screenshot"/> */}
        </div>
        <div class="relative">
      {/* <div class="absolute inset-0 flex flex-col" aria-hidden="true">
        <div class="flex-1"></div>
        
      </div> */}
     
    </div>
  
        <div class="relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
          <div className="wrap">
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
            <div class="c"></div>
          </div>
        </div>
      </main>
    </div>
   /*  </div> */
  );
}
